import { ThemeProvider } from "@emotion/react"
import { ThemeDetails } from "./ThemeDetails"
import { CssBaseline } from "@mui/material"


type AppThemeProps = {
    children: React.ReactNode; // Esto define el tipo de `children`
};

export const AppTheme = ({ children }: AppThemeProps) => {
    return (
        <ThemeProvider theme={ThemeDetails}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    )
}
